import React, { useEffect, useState } from 'react';
import useDragTranslate from '../hooks/useDragTranslate';
import { getRandomWindowPosition } from '../utils/windowPositioning';
import TEXT from '../constants/text';

const AboutWindow = ({ onClose, zIndex, onFocus }) => {
  const { elRef, onPointerDown, onPointerMove, onPointerUp } = useDragTranslate(onFocus);
  
  // Generate random position for this window
  const [windowPosition] = useState(() => getRandomWindowPosition(640, 500));
  
  const handleFocus = () => {
    onFocus && onFocus();
    /* bring window to front when clicked */
  };

  const handleClose = () => {
    // 1) Add .closing
    elRef.current?.classList.add('closing');

    // 2) After animation end, call onClose to unmount
    const done = () => {
      elRef.current?.removeEventListener('animationend', done);
      onClose();
    };
    elRef.current?.addEventListener('animationend', done, { once: true });
  };

  useEffect(() => {
    // listen on the document so we can move outside the window bounds
    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerUp);
    return () => {
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
    };
  }, [onPointerMove, onPointerUp]);

  return (
    <div
      ref={elRef}
      className="window"
      data-window="about"
      style={{
        display: 'block',
        width: '640px',
        zIndex: zIndex,
        position: 'fixed',
        '--tx': `${windowPosition.tx}px`,
        '--ty': `${windowPosition.ty}px`,
        // IMPORTANT: do NOT set left/top/transform here; CSS handles it.
      }}
      onClick={handleFocus}
    >
      <div className="title-bar draggable" onPointerDown={onPointerDown}>
        <div className="title-bar-text">About Avo - Portfolio.exe</div>
        <div className="title-bar-controls">
          <button aria-label="Close" onClick={handleClose}></button>
        </div>
      </div>
      <div className="window-body">
        <h1 className="greeting">{TEXT.ABOUT.CONTENT.GREETING}</h1>
        <img src={TEXT.ABOUT.CONTENT.IMAGE} alt="Avo" className="about-image" />
        <h2 className="description" dangerouslySetInnerHTML={{ __html: TEXT.ABOUT.CONTENT.DESCRIPTION }}></h2>
        <h2 className="description">{TEXT.ABOUT.CONTENT.BIO}</h2>
        <h2 className="description">{TEXT.ABOUT.CONTENT.BIO2}</h2>
        
        <div className="trivia-section">
          <h3 className="trivia-title">{TEXT.ABOUT.CONTENT.TRIVIA.TITLE}</h3>
          <div className="trivia-questions">
            {TEXT.ABOUT.CONTENT.TRIVIA.QUESTIONS.map((item, index) => (
              <div key={index} className="trivia-item">
                <span className="trivia-question">{item.question}:</span>
                <span className="trivia-answer">{item.answer}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutWindow;
